import { getSpuDetail, getOfferRecord, skuUpdate, postSpuUpdate } from '@/api';
import { CardItem, ExportData, HeaderTitle, Operation, Thumbnails } from '@/components';
import { calcPrice, parseJSON, toDateTime, toSpliceStr } from '@/utils/utils';
import { Button, Card, DatePicker, Image, Input, message, Modal } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { st_spu, st_user } from '@/utils/statetype';
import locale from 'antd/es/date-picker/locale/zh_CN';
import OfferList from './offerList';

const { statusObj, typeObj, kindObj } = st_spu;
const { statusObj: statusObjs } = st_user;
const pageSize = 8;
function SpuListDetail({ querys }) {
  const { i: ID } = querys;
  let times = useRef(null);
  const [datas, setDatas] = useState({});
  const [refuse, setRefuse] = useState('');
  const [record, setRecord] = useState({});
  const [preview, setPreview] = useState(false);
  const [pageNo, setPageNo] = useState(1);
  const info = parseJSON(datas.info) || {};
  const property = parseJSON(datas.property);
  const { Merchant = {}, Skus = [] } = datas;

  const handleGetData = () => {
    getSpuDetail({
      query: {
        id: Number(ID),
      },
    }).then(res => {
      setDatas(res);
    });
  };

  useEffect(() => {
    handleGetData();
  }, []);

  const handleSubmit = status => {
    if (status === -1 && !refuse) {
      message.warning('拒绝时请输入审核意见');
      return;
    }
    postSpuUpdate({
      body: {
        ids: [Number(ID)],
        ...(status === -10
          ? {
            refuseReason: refuse,
          }
          : {}),
        status,
      },
    }).then(() => {
      message.success('操作成功');
      handleGetData();
    });
  };

  const renderInfo = [
    {
      label: '商品编号',
      render: datas.id,
    },
    {
      label: '商品名称',
      render: datas.name,
    },
    {
      label: '商品描述',
      render: info.describe,
    },
    {
      label: '封面图',
      render: <Thumbnails images={[datas.thumb]} />,
    },
    {
      label: '兑换商品轮播图',
      // render: <Thumbnails images={datas.bannerImage?.split(',') || []} />,
      render: (datas.bannerImage?.split(",") || []).map(i => {
        return <span style={{ marginRight: '10px' }}>
          <Image
            // width={50}
            // padding-right='10px'
            height={50}
            src={i}
          />
        </span>
      }),
    },
    {
      label: '服务标签',
      render: (datas.Labels || []).map(i => i.name).join('|'),
    },
    {
      label: '3级自填分类',
      render: toSpliceStr(property, '>'),
    },
    {
      label: '商品类型',
      render: typeObj[datas.type],
    },
    {
      label: '商品类别',
      render: kindObj[datas.kind],
    },

    {
      label: '详情图',
      // render: <Thumbnails images={(datas.image ?? '').split(',')} />,
      render: (datas.image?.split(",") || []).map(i => {
        return <span style={{ marginRight: '10px' }}>
          <Image
            // width={50}
            // padding-right='10px'
            height={50}
            src={i}
          />
        </span>
      }),
    },
    {
      label: '鉴定证书',
      // render: <Thumbnails images={(datas.credNote ?? '').split(',')} />,
      render: (datas.credNote?.split(",") || []).map(i => {
        return <span style={{ marginRight: '10px' }}>
          <Image
            // width={50}
            // padding-right='10px'
            height={50}
            src={i}
          />
        </span>
      }),
    },
    {
      label: '商品视频',
      render: datas.videoThumb ? (
        <Image
          width={64}
          height={64}
          src={datas.videoThumb}
          style={{ objectFit: 'cover' }}
          preview={{
            visible: false,
            onVisibleChange: e => {
              if (e && !datas.video) {
                message.warning('没有视频资源！');
                return;
              }
              setPreview(e);
            },
          }}
        />
      ) : (
        '-'
      ),
    },
    {
      label: '转拍次数',
      render: datas.resellCount,
    },
    {
      label: '创建时间',
      render: toDateTime(datas.createdAt),
    },
  ];

  const renderStatus = [
    {
      label: '商品状态',
      render: statusObj[datas.status],
    },
    {
      label: '审核意见',
      render:
        datas.status === 0 ? (
          <Input.TextArea
            placeholder="请输入审核意见（拒绝理由）"
            onChange={e => setRefuse(e.target.value)}
          />
        ) : (
          datas.refuseReason
        ),
    },
    {
      render: datas.status === 0 && (
        <>
          <Button type="primary" style={{ marginRight: '16px' }} onClick={() => handleSubmit(20)}>
            同意
          </Button>
          <Button type="primary" danger onClick={() => handleSubmit(-10)}>
            拒绝
          </Button>
        </>
      ),
    },
  ];

  const renderShop = [
    {
      label: '店铺名称',
      render: Merchant.title,
    },
    {
      label: '店铺LOGO',
      render: <Thumbnails images={[Merchant.shopIcon]} />,
    },
    {
      label: '联系方式',
      render: Merchant.contact,
    },
    {
      label: '店铺地址',
      render: Merchant.address,
    },
  ];

  const renderSchedules = {
    dataSource: Skus,
    columns: [
      {
        title: '编号',
        dataIndex: 'id',
      },
      {
        title: '类型',
        dataIndex: 'type',
        render: e => typeObj[e],
      },
      {
        title: '规格',
        dataIndex: 'attribute',
      },
      {
        title: '转拍人编号',
        dataIndex: 'resellUserId',
      },
      {
        title: '转拍订单编号',
        dataIndex: 'resellOrderId',
      },
      {
        title: '成交订单编号',
        dataIndex: 'orderId',
      },
      {
        title: '加价幅度',
        dataIndex: 'addPriceRange',
        render: e => calcPrice(e),
      },
      {
        title: '保证金比例',
        dataIndex: 'bondPro',
      },
      {
        title: '起始价',
        dataIndex: 'startPrice',
        render: e => calcPrice(e),
      },
      {
        title: '当前价',
        dataIndex: 'currentPrice',
        render: e => calcPrice(e),
      },
      {
        title: '认购价',
        dataIndex: 'subscriptionPrice',
        render: e => calcPrice(e),
      },
      {
        title: '最终价',
        dataIndex: 'finalPrice',
        render: e => calcPrice(e),
      },
      {
        title: '贡献值',
        dataIndex: 'contributionPrice',
        render: e => calcPrice(e),
      },
      {
        title: '标品数量',
        dataIndex: 'num',
      },
      {
        title: '标品单位',
        dataIndex: 'unit',
      },
      {
        title: '库存',
        dataIndex: 'stock',
        // toDateTime(datas.createdAt),
        render: e => e || "-",
      },
      {
        title: '竞拍次数',
        dataIndex: 'offerNums',
      },
      {
        title: '竞拍人数',
        dataIndex: 'offerCount',
      },
      {
        title: '开始时间',
        dataIndex: 'startTime',
        render: e => toDateTime(e),
      },
      {
        title: '结束时间',
        dataIndex: 'endTime',
        render: e => toDateTime(e),
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        render: e => toDateTime(e),
      },
      {
        title: '操作',
        render: record => (
          <Operation
            disabled={{
              update: ![20, 100].includes(record.status),
            }}
            listData={{
              update: () => {
                Modal.confirm({
                  icon: null,
                  title: '更改排期时间',
                  content: (
                    <DatePicker.RangePicker
                      showTime
                      locale={locale}
                      onChange={e => (times.current = e)}
                    />
                  ),
                  onOk: () => handleUpdateTime(record.id),
                });
              },
            }}
          />
        ),
      },
    ],
  };

  const handleUpdateTime = id => {
    if (!times || !times.current) {
      return message.warning('排期时间未输入');
    }
    const [s, e] = times.current;
    skuUpdate({
      body: {
        id,
        startTime: toDateTime(s),
        endTime: toDateTime(e),
      },
    }).then(() => {
      message.success('修改成功');
      handleGetData();
    });
  };

  const renderLogs = {
    dataSource: datas.SpuLogs,
    columns: [
      {
        title: '编号',
        dataIndex: 'id',
      },
      {
        title: '备注信息',
        dataIndex: 'remark',
      },
      {
        title: '最近修改',
        dataIndex: 'updatedAt',
        render: e => toDateTime(e),
      },
      {
        title: '创建时间',
        dataIndex: 'createdAt',
        render: e => toDateTime(e),
      },
    ],
  };

  return (
    <>
      <HeaderTitle />
      <Card>
        <CardItem title={'基本信息'} datas={renderInfo} />
        <CardItem title={'所属店铺'} datas={renderShop} />
        <CardItem title={'审核信息'} datas={renderStatus} />
        {!!Skus.length && <CardItem title={'SKU'} datas={renderSchedules} />}
        {/* <CardItem title={'竞拍记录'} datas={renderRecord} /> */}
        <OfferList spu={datas} />
        <CardItem title={'操作日志'} datas={renderLogs} />
      </Card>
      <Modal
        width={960}
        footer={null}
        destroyOnClose
        closable={false}
        visible={preview}
        bodyStyle={{ padding: '0', backgroundColor: '#000', display: 'flex' }}
        onCancel={() => setPreview(false)}
      >
        <video
          muted
          controls
          autoPlay
          width={960}
          height={660}
          autobuffer="true"
          style={{ width: '100%', height: '100%', maxHeight: '660px', background: '#000' }}
          src={datas.video}
        />
      </Modal>
    </>
  );
}

export default SpuListDetail;
